import React from "react";
import ReactDOM from "react-dom";
import SimController from "../../../javascript/simController";
import VRController from "../VRComponent/components/VRController";
import "../../../scss/reset.scss";
import isVRReady from "../../../javascript/isVRReady";

window.onload = () => {
    ReactDOM.render(
        <SimController height={"56vw"} isFullwindow={isVRReady()}>
            <VRController
                imgSrc={require("./assets/tundra.jpg")}
                title={"Tundra biome"}
            />
        </SimController>,
        document.querySelector("#react-components"),
    );
};
